import { useMutation, useQueryClient } from '@tanstack/react-query'
import { buyDomain } from '../../services'
import { AdminMutationKey, AdminQueryKey } from '@/modules/admin/keys'
import { BuyDomainRequest, BuyDomainResponse } from '@/modules/admin/type'
import { toast } from 'sonner'

export default function useMutationBuyDomain() {
	const queryClient = useQueryClient()

	return useMutation<BuyDomainResponse, Error, BuyDomainRequest>({
		mutationKey: [AdminMutationKey.BuyDomain],
		mutationFn: (payload: BuyDomainRequest) => buyDomain(payload),
		onSuccess: (data) => {
			toast.success(data.message || 'ซื้อโดเมนสำเร็จ')
			queryClient.invalidateQueries({ queryKey: [AdminQueryKey.GetDomains] })
			queryClient.invalidateQueries({
				queryKey: [AdminQueryKey.GetDomainQuota],
			})
		},
		onError: () => {
			toast.error('ซื้อโดเมนล้มเหลว กรุณาลองใหม่อีกครั้ง')
		},
	})
}
